export const featuredComics = [
  {
    id: 1,
    title: '绝世神医',
    author: '金泰亨',
    category: '奇幻冒险',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20cover%20art%2C%20fantasy%20genre%2C%20male%20protagonist%20with%20dark%20hair%20in%20traditional%20robe%2C%20magical%20elements%2C%20dramatic%20lighting%2C%20illustration%20style%2C%20clean%20background%2C%20professional%20digital%20art%2C%20vibrant%20colors%2C%20webtoon%20style%20cover&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '一位现代神医意外穿越到异世界，凭借超凡医术纵横天下。',
    rating: 9.5,
    views: '1280万',
    chapters: 156,
    status: '连载中',
    updateDate: '2026-07-02',
    tags: ['穿越', '医术', '热血'],
  },
  {
    id: 2,
    title: '暗夜君主',
    author: '李智恩',
    category: '悬疑惊悚',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20cover%2C%20dark%20mystery%20thriller%20genre%2C%20male%20character%20in%20black%20suit%20with%20intense%20gaze%2C%20noir%20atmosphere%2C%20city%20night%20background%2C%20dramatic%20contrast%2C%20illustration%20style%2C%20webtoon%20cover%20design&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '夜幕降临，隐藏在都市阴影中的超能力者开始了他们的战争。',
    rating: 9.3,
    views: '980万',
    chapters: 89,
    status: '连载中',
    updateDate: '2026-07-01',
    tags: ['都市', '超能力', '悬疑'],
  },
  {
    id: 3,
    title: '甜蜜陷阱',
    author: '朴秀英',
    category: '恋爱言情',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%2C%20beautiful%20female%20and%20male%20characters%20facing%20each%20other%2C%20soft%20pastel%20colors%2C%20cherry%20blossom%20petals%2C%20romantic%20atmosphere%2C%20illustration%20style%2C%20webtoon%20cover%20design%2C%20clean%20composition&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '顶级财阀继承人与普通女孩之间甜蜜又危险的契约恋爱。',
    rating: 9.7,
    views: '1560万',
    chapters: 203,
    status: '已完结',
    updateDate: '2026-06-15',
    tags: ['恋爱', '财阀', '契约'],
  },
  {
    id: 4,
    title: '剑与魔法',
    author: '崔珉豪',
    category: '奇幻冒险',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%2C%20knight%20with%20sword%20in%20epic%20battle%20pose%2C%20magical%20effects%2C%20medieval%20fantasy%20setting%2C%20dramatic%20action%20scene%2C%20illustration%20style%2C%20webtoon%20cover%2C%20dynamic%20composition&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '在剑与魔法交织的世界中，少年踏上成为最强骑士的征途。',
    rating: 9.1,
    views: '820万',
    chapters: 178,
    status: '连载中',
    updateDate: '2026-07-03',
    tags: ['奇幻', '战斗', '成长'],
  },
  {
    id: 5,
    title: '逆天邪神',
    author: '郑秀晶',
    category: '玄幻仙侠',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20cover%2C%20powerful%20male%20warrior%20with%20flowing%20hair%2C%20martial%20arts%20stance%2C%20oriental%20fantasy%20atmosphere%2C%20energy%20effects%2C%20illustration%20style%2C%20webtoon%20cover%2C%20epic%20composition&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '一代邪神重生归来，这一次，他要让整个修炼界为之颤抖。',
    rating: 9.4,
    views: '1860万',
    chapters: 312,
    status: '连载中',
    updateDate: '2026-07-02',
    tags: ['重生', '修炼', '爽文'],
  },
  {
    id: 6,
    title: '校园秘语',
    author: '金多美',
    category: '校园青春',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20school%20life%20manhwa%20cover%2C%20students%20in%20school%20uniform%20at%20sunset%2C%20youthful%20atmosphere%2C%20warm%20color%20tones%2C%20friendship%20theme%2C%20illustration%20style%2C%20webtoon%20cover%20design%2C%20nostalgic%20feeling&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '转学生发现学校隐藏的秘密社团，平凡校园生活从此改变。',
    rating: 8.9,
    views: '650万',
    chapters: 67,
    status: '连载中',
    updateDate: '2026-06-30',
    tags: ['校园', '秘密', '青春'],
  },
  {
    id: 7,
    title: '末日庇护所',
    author: '朴叙俊',
    category: '科幻末世',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20post%20apocalyptic%20manhwa%20cover%2C%20survivors%20in%20destroyed%20city%2C%20sci-fi%20elements%2C%20dramatic%20lighting%2C%20dark%20atmosphere%2C%20illustration%20style%2C%20webtoon%20cover%2C%20intense%20mood&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '末日降临，幸存者们为了最后的希望展开殊死搏斗。',
    rating: 9.2,
    views: '1120万',
    chapters: 145,
    status: '连载中',
    updateDate: '2026-07-01',
    tags: ['末世', '生存', '科幻'],
  },
  {
    id: 8,
    title: '职场风云',
    author: '宋慧乔',
    category: '都市职场',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20office%20drama%20manhwa%20cover%2C%20professional%20woman%20in%20modern%20office%2C%20city%20skyline%20through%20window%2C%20chic%20style%2C%20illustration%20style%2C%20webtoon%20cover%20design%2C%20sophisticated%20atmosphere&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '职场新人如何在残酷的竞争环境中一步步爬上顶峰。',
    rating: 8.7,
    views: '720万',
    chapters: 98,
    status: '已完结',
    updateDate: '2026-05-20',
    tags: ['职场', '成长', '女性'],
  },
];

export const categories = [
  { id: 1, name: '奇幻冒险', count: 528, icon: 'ri-magic-line', description: '剑与魔法的奇幻世界' },
  { id: 2, name: '恋爱言情', count: 436, icon: 'ri-heart-line', description: '甜蜜浪漫的爱情故事' },
  { id: 3, name: '悬疑惊悚', count: 287, icon: 'ri-ghost-line', description: '烧脑悬疑的惊险旅程' },
  { id: 4, name: '玄幻仙侠', count: 395, icon: 'ri-sword-line', description: '东方玄幻的修炼之路' },
  { id: 5, name: '校园青春', count: 312, icon: 'ri-book-open-line', description: '青春校园的精彩日常' },
  { id: 6, name: '科幻末世', count: 198, icon: 'ri-rocket-line', description: '未来世界的科幻想象' },
  { id: 7, name: '都市职场', count: 245, icon: 'ri-building-line', description: '都市生活的百态人生' },
  { id: 8, name: '历史古风', count: 176, icon: 'ri-ancient-gate-line', description: '穿越历史的传奇故事' },
];

export const faqData = [
  {
    question: '韩漫漫画网的漫画资源多吗？',
    answer: '我们拥有超过2500部韩国漫画资源，涵盖奇幻冒险、恋爱言情、悬疑惊悚、玄幻仙侠、校园青春、科幻末世、都市职场、历史古风等八大品类。每天持续更新，确保您不错过任何精彩内容。所有漫画均为高清画质，加载速度快，让您畅享阅读体验。',
  },
  {
    question: '需要注册才能观看漫画吗？',
    answer: '不需要！韩漫漫画网坚持免费开放原则，所有漫画均可直接在线阅读，无需注册账号。我们致力于为漫画爱好者提供最便捷的阅读体验，让您随时随地畅享韩漫世界的精彩。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '我们与多家韩国漫画平台保持紧密合作，热门连载作品基本实现同步更新。一般情况下，热门作品的更新延迟不超过24小时。我们的编辑团队全天候监控更新动态，第一时间为您呈现最新章节。',
  },
  {
    question: '可以在手机上观看吗？',
    answer: '当然可以！韩漫漫画网采用响应式设计，完美适配手机、平板和电脑等各种设备。无论您使用什么设备访问，都能获得最佳的阅读体验。页面自适应屏幕大小，漫画图片清晰流畅。',
  },
  {
    question: '漫画的清晰度如何？',
    answer: '我们平台所有漫画均提供高清画质，原图分辨率高达1600px以上，确保每一处细节都清晰可见。同时我们采用先进的图片压缩技术，在保证画质的前提下优化加载速度，让您享受流畅无卡顿的阅读体验。',
  },
];

export const reviews = [
  {
    id: 1,
    username: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20anime%20style%20male%20portrait%20avatar%2C%20young%20man%20with%20stylish%20hair%2C%20warm%20smile%2C%20simple%20soft%20background%2C%20illustration%20style%2C%20clean%20design&width=200&height=200&seq=avatar-01&orientation=squarish',
    content: '韩漫漫画网真的是我发现的最好的韩漫阅读平台！资源超级全，更新速度也很快，画质清晰到每一个细节都能看清楚。最赞的是完全免费，不需要注册就能看，太太太良心了！推荐给所有喜欢韩漫的朋友！',
    rating: 5,
    level: '资深读者',
    date: '2026-06-28',
  },
  {
    id: 2,
    username: '追漫达人',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20anime%20style%20female%20portrait%20avatar%2C%20young%20woman%20with%20long%20dark%20hair%2C%20gentle%20expression%2C%20soft%20background%2C%20illustration%20style%2C%20clean%20design&width=200&height=200&seq=avatar-02&orientation=squarish',
    content: '以前在其他平台看韩漫总是要等很久更新，自从来了韩漫漫画网，热门作品的更新速度快得让我惊喜！而且分类做得很好，每次都能很快找到自己喜欢的类型。手机看也特别方便，通勤路上必备！',
    rating: 5,
    level: 'VIP会员',
    date: '2026-06-25',
  },
  {
    id: 3,
    username: '二次元阿宅',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20anime%20style%20male%20portrait%20avatar%2C%20young%20man%20with%20glasses%2C%20friendly%20smile%2C%20simple%20background%2C%20illustration%20style%2C%20clean%20design&width=200&height=200&seq=avatar-03&orientation=squarish',
    content: '画质真的没话说！在其他平台看同一部漫画，韩漫漫画网的高清画质体验完全不一样。加载速度也很快，翻页丝滑不卡顿。界面设计也很清爽，没有烦人的广告弹窗，阅读体验拉满！',
    rating: 5,
    level: '资深读者',
    date: '2026-06-22',
  },
];

export const aboutStats = [
  { label: '入驻作品', value: '2,500+', suffix: '部' },
  { label: '日活用户', value: '85', suffix: '万+' },
  { label: '均分评分', value: '9.2', suffix: '分' },
  { label: '签约作者', value: '320+', suffix: '位' },
];

export const aboutAdvantages = [
  { id: 1, title: '资源丰富', description: '2500+韩漫作品，八大品类全覆盖，满足各类阅读需求' },
  { id: 2, title: '更新极速', description: '与韩国平台同步更新，热门作品24小时内上线最新章节' },
  { id: 3, title: '高清画质', description: '原图1600px+分辨率，细节纤毫毕现，沉浸式阅读体验' },
  { id: 4, title: '社区活跃', description: '百万读者在线互动，热门评论和评分帮你发现好作品' },
];